import Vue from 'vue'
import Router from 'vue-router'

const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/account_login',
    name: 'login',
    // component: () => import('./views/login/Login'),
    // meta: {}
    redirect: () => {
      window.location.href = 'https://recapi.ustc.edu.cn/identity/other_login?client_id=f10f162e-3945-4183-b2b9-f7afe472615f&key=https%3A%2F%2Frec.ustc.edu.cn%2Flogin_terminal';
    },
  },
  // {
  //   path: '/login_cas',
  //   name: 'caslogin',
  //   component: () => import('./views/login/CasLogin'),
  //   meta: {}
  // },
  {
    path: '/login_terminal',
    name: 'login_terminal',
    component: () => import('./views/login/LoginFromPc')
  },
  {
    path: '/preview/:number/:group_number/:version?',
    name: 'preview',
    component: () => import('./views/Search/Preview'),
    meta: {}
  },
  {
    path: '/linked/:link_number/:resource_number',
    name: 'linkd',
    component: () => import('./components/Table/Linked')
  },
  {
    path: '',
    component: () => import('./views/Common/Layout'),
    meta: {},
    children: [
      {
        path: '/',
        name: 'index',
        component: () => import('./views/Index'),
        meta: {}
      },
      {
        path: '/content',
        name: 'content',
        component: () => import('./views/Common/Content'),
        meta: {}
      },
      {
        path: '/faq',
        name: 'faq',
        component: () => import('./views/Common/Faq'),
        meta: {}
      },
      {
        path: '/apply_temp_account',
        name: 'applyTempAccount',
        component: () => import('./views/Common/ApplyTempAccount'),
        meta: {}
      },
      {
        path: '/delay_temp_account',
        name: 'delayTempAccount',
        component: () => import('./views/Common/DelayTempAccount'),
        meta: {}
      },
      {
        path: '/privacy_policy',
        name: 'privacyPolicy',
        component: () => import('./views/Common/PrivacyPolicy'),
        meta: {}
      },
      {
        path: '/windows_update',
        name: 'windowsUpdate',
        component: () => import('./views/Common/WindowsUpdate'),
        meta: {}
      },
      {
        path: '/encryption',
        name: 'encryption',
        component: () => import('./views/Common/Encryption'),
        meta: {}
      },
      {
        path: '/profile',
        name: 'persona',
        component: () => import('./views/persona/Persona'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/user/infomation',
        name: 'personaInfo',
        component: () => import('./views/persona/PersonaInfo'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/user/infomation/edit',
        name: 'editpersonaInfo',
        component: () => import('./views/persona/EditPersonaInfo'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/user/change/password',
        name: 'changePwd',
        component: () => import('./views/persona/ChangePwd'),
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/download',
        name: 'download',
        component: () => import('./views/Common/Download'),
        meta: {}
      },
      {
        path: '/download/windows/sync',
        name: 'downloadWindowsSync',
        component: () => import('./views/Common/DownloadWindowsSync'),
        meta: {}
      },
      // {
      //   path: '/download/iphone/sync',
      //   name: 'downloadIphoneSync',
      //   component: () => import('./views/Common/DownloadIphoneSync'),
      //   meta: {}
      // },
      {
        path: '/download/android',
        name: 'downloadAndroid',
        component: () => import('./views/Common/DownloadAndroid'),
        meta: {}
      },
      {
        path: '/download/iphone',
        name: 'downloadIphone',
        component: () => import('./views/Common/DownloadIphone'),
        meta: {}
      },
      {
        path: '',
        component: () => import('./views/Search/SearchHeader'),
        children: [
          {
            path: '/search/file',
            name: 'searchFile',
            component: () => import('./views/Search/SearchFile')
          },
          {
            path: '/search/folder',
            name: 'searchFolder',
            component: () => import('./views/Search/SearchFolder')
          },
          {
            path: '/search/group',
            name: 'searchGroup',
            component: () => import('./views/Search/SearchGroup')
          },
        ]
      },
      {
        path: '/recdrive',
        name: 'recdrive',
        component: () => import('./views/CloudDisk/DiskWraper')
      },
      {
        path: '/drive/:tab',
        name: 'recdriveByTab',
        component: () => import('./views/CloudDisk/DiskWraper')
      },
      {
        path: '/share/:share_number',
        name: 'sharelink',
        component: () => import('./components/Table/ShareLink')
      },
      {
        path: '/link/:link_number',
        name: 'sendlink',
        component: () => import('./components/Table/SendLink')
      },
      {
        path: '/user/:userNumber',
        name: 'user',
        component: () => import('./views/User/User')
      },
      {
        path: '',
        component: () => import('./views/GroupList/GroupHeader'),
        children: [
          {
            path: 'grouplist',
            name: 'grouplist',
            component: () => import('./views/GroupList/GroupList'),
            meta: {}
          },
          {
            path: 'groupmsg',
            name: 'groupmsg',
            component: () => import('./views/GroupList/GroupMsg'),
            meta: {}
          }
        ]
      },
      {
        path: '',
        component: () => import('./views/Group/GroupWraper'),
        meta: {},
        children: [
          {
            path: '/group/:groupNumber/home',
            name: 'group',
            component: () => import('./views/Group/GroupHome'),
            meta: {}
          },
          {
            path: '/group/:groupNumber/member',
            name: 'groupMember',
            component: () => import('./views/Group/GroupMember'),
            meta: {}
          },
          {
            path: '/group/:groupNumber/topic',
            name: 'groupTopic',
            component: () => import('./views/Group/GroupTopic'),
            meta: {}
          },
          {
            path: '/group/:groupNumber/disk',
            name: 'groupDisk',
            component: () => import('./views/Group/GroupDisk'),
            meta: {}
          }
        ]
      },
      {
        path: '/images',
        name: 'images',
        component: () => import('./views/Apps/Images'),
        meta: {}
      },
      {
        path: '/videos',
        name: 'videos',
        component: () => import('./views/Apps/Videos'),
        meta: {}
      },
      {
        path: '/word',
        name: 'word',
        component: () => import('./views/Apps/Word'),
        meta: {}
      },
      {
        path: '/excel',
        name: 'excel',
        component: () => import('./views/Apps/Excel'),
        meta: {}
      },
      {
        path: '/ppt',
        name: 'ppt',
        component: () => import('./views/Apps/PPT'),
        meta: {}
      },
      {
        path: '/pdf',
        name: 'pdf',
        component: () => import('./views/Apps/PDF'),
        meta: {}
      },
      {
        path: '/markdown',
        name: 'markdown',
        component: () => import('./views/Apps/Markdown'),
        meta: {}
      },
      {
        path: '',
        component: () => import('./views/UpdateLog/UpdateLogWraper'),
        children: [
          {
            path: '/updatelog',
            name: 'updatelog',
            component: () => import('./views/UpdateLog/Web'),
          },
          {
            path: '/updatelog/windows',
            name: 'updatelogWindows',
            component: () => import('./views/UpdateLog/Windows'),
          },
          {
            path: '/updatelog/android',
            name: 'updatelogAndroid',
            component: () => import('./views/UpdateLog/Android'),
          },
          {
            path: '/updatelog/iphone',
            name: 'updatelogIphone',
            component: () => import('./views/UpdateLog/Iphone'),
          },
          {
            path: '/updatelog/windows/sync',
            name: 'updatelogWindowsSync',
            component: () => import('./views/UpdateLog/WindowsSync'),
          },
          // {
          //   path: '/updatelog/iphone/sync',
          //   name: 'updatelogIphoneSync',
          //   component: () => import('./views/UpdateLog/IphoneSync'),
          // }
        ]
      }
    ]
  },
  {
    path: '/404',
    name: '404',
    component: () => import('./views/Common/404'),
    meta: {}
  },
  {
    path: '*',
    name: 'notFound',
    redirect: '/404',
    hidden: true,
    meta: {}
  }
]

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: constantRouterMap
})
